<template>
  <div class="index-about-section">
    <div class="main-container">
      <div class="logo">
        <img src="../../assets/logo/seu-logo-name-black.svg" alt="">
      </div>

      <div class="content">
        <div class="heading-3-bold" v-html="fields.field_one.value.text1">

        </div>
        <div class="paragraph-1-large" v-html="fields.field_one.value.text2 ">

        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    fields: {}
  }
}
</script>

<style lang="scss">
@import "IndexAboutSection";
</style>
